import Super from './-resources';
import classic from 'ember-classic-decorator';

@classic
export default class SiteBillingInvoices extends Super {}
